import {NEUTRAL_PLAYER_ID} from "../../constants/players";

export const checkIfNeutralPlayer = (playerId) => {
  return playerId === NEUTRAL_PLAYER_ID;
}